// extracted by mini-css-extract-plugin
export default {"item":"Profile_item__z2kfW","icon":"Profile_icon__0qiQa","labelIcon":"Profile_labelIcon__bXgKK"};